/** Auth actiontypes */
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const USER = 'USER';
export const AUTH_DATA = 'AUTH_DATA';
export const LOG_OUT = 'LOG_OUT';
export const API_LOADING = 'API_LOADING';
